import { render, staticRenderFns } from "./ViewLayoutDefault.vue?vue&type=template&id=b056db8c"
import script from "./ViewLayoutDefault.vue?vue&type=script&lang=js"
export * from "./ViewLayoutDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports